function PageLoading({ label }) {
  return (
    <div className="py-12 bg-white relative">
      <div className="h-full flex items-center justify-center">
        <div className="flex flex-col items-center">
          {/* Loading Spinner */}
          <div className="relative">
            {/* Main spinner */}
            <div className="w-16 h-16 border-4 border-gray-200 rounded-full animate-spin border-t-indigo-600"></div>

            {/* Pulse effect */}
            <div className="absolute inset-0 w-16 h-16 border-4 border-indigo-100 rounded-full animate-ping opacity-20"></div>
          </div>

          {/* Loading dots */}
          <div className="flex justify-center mt-6 space-x-1">
            <div
              className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce"
              style={{ animationDelay: "0ms" }}
            ></div>
            <div
              className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce"
              style={{ animationDelay: "150ms" }}
            ></div>
            <div
              className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce"
              style={{ animationDelay: "300ms" }}
            ></div>
          </div>

          {/* Loading text */}
          <div className="mt-4 text-center">
            <p className="text-base font-medium text-gray-900">
              {label}
            </p>
            <p className="mt-1 text-sm text-gray-500">
              Please wait while we gather your information...
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageLoading;
